import { memo } from 'react';
import { withNamespaces } from 'react-i18next';

import { getCrossCheckStatusConfig } from '../constants/crossCheckStatusConfig';

const CrossCheckCell = ({
    t,
    value,
}) => {
    const config = getCrossCheckStatusConfig(value);

    return (
        <span
            className="overview-cross-check-analysis__cell-value"
            style={{ color: config.color }}
        >
            {value === 'not_available' ? config.label : t(config.label)}
        </span>
    );
};

export default withNamespaces()(memo(CrossCheckCell));
